import Axios from 'axios'
import i18n from 'i18next'

const headers = localStorage.getItem('token')
    ? {Authorization: ` bearer ${localStorage.getItem('token')}`}
    : undefined

const http = Axios.create({headers})

http.interceptors.request.use((r) => {
    r.headers["Accept-Language"] = i18n.language
    return r
})

http.interceptors.response.use(
    (r) => r,
    (error) => {
        if (
            error.response.status === 503 &&
            window.location.pathname !== '/503'
        ) {
            window.location.href = window.location.origin + '/503'
        }

        return Promise.reject(error)
    }
)

export default http
